import { useDispatch } from "react-redux";
import { deleteCommunity } from "../../../API/store/actions/admin/communitiesAction";
import Button from "../../sharedComponents/buttons/button";

const DeleteCommunity = ({ userToken, modalVisible, setModalVisible }) => {
  const dispatch = useDispatch();

  return (
    <div className=" d-flex flex-column  align-items-center justify-content-center">
      <img src="/assets/images/fi-br-info.png" alt="" />
      <div className="my-2">تاكيد حذف محور العمل</div>
      <div className="d-flex justify-content-center flex-wrap w-100 my-3">
        <Button
          containerStyle={"col-3 mx-2 "}
          content={"نعم"}
          buttonStyleType="solid"
          onClick={async () => {
            let res = await deleteCommunity(
              modalVisible?.helperData?.id,
              userToken
            );
            if (res?.status <= 206) {
              dispatch({ type: "RELOAD" });
              setModalVisible({
                ...modalVisible,
                deleteCommunity: false,
                helperData: null,
              });
            }
          }}
        />
        <Button
          containerStyle={"col-3 mx-2"}
          content={"لا"}
          onClick={() => {
            setModalVisible({
              ...modalVisible,
              deleteCommunity: false,
              helperData: null,
            });
          }}
        />
      </div>
    </div>
  );
};

export default DeleteCommunity;
